/* eslint-disable office-addins/no-navigational-load */
/* global Word console */
import { CanvasChange } from "../types";

/**
 * Given a change to a text range, apply the changes.
 * @param target - The text range/run to apply the changes to.
 * @param change - The change to apply to the text range.
 * @param context - The context to use to apply the changes.
 */
export async function applyTextChanges(target: Word.Range, change: CanvasChange, context: Word.RequestContext) {
  const textRanges = target.getTextRanges([" "], false);
  textRanges.load("items/i");
  await context.sync();
  let i = 0;
  let groupedChange: { range: Word.Range; newText: string } | undefined = undefined;
  for (const childChange of change.child_changes) {
    let currentRange = textRanges.items[i];
    let newText = "";

    if (childChange.op === "~" && change.child_changes[i + 1]?.op === "~") {
      if (!groupedChange) {
        groupedChange = { range: currentRange, newText: "" };
      }
      groupedChange.newText += childChange.e2;
      groupedChange.range = groupedChange.range.expandTo(currentRange);
      i++;
      continue;
    }

    switch (childChange.op) {
      case "=":
        i++;
        break;
      case "+":
        if (typeof childChange.e2 !== "string") {
          throw new Error("Child change type mismatch");
        }
        newText = childChange.e2;
        if (!currentRange) {
          currentRange = textRanges.items[textRanges.items.length - 1];
          const newRange = currentRange.insertText(newText, Word.InsertLocation.end);
          textRanges.items.push(newRange);
          i++;
        } else {
          currentRange.insertText(newText, Word.InsertLocation.before);
        }
        break;
      case "-":
        if (!currentRange) {
          throw new Error("Cannot remove text from non-existing range");
        }
        currentRange.insertText("", Word.InsertLocation.replace);
        i++;
        break;
      case "~":
        if (typeof childChange.e2 !== "string") {
          throw new Error("Child change type mismatch");
        }
        if (groupedChange) {
          currentRange = currentRange.expandTo(groupedChange.range);
          newText = groupedChange.newText + childChange.e2;
          console.log("Editing text", newText, "at once");
          groupedChange = undefined;
        } else {
          newText = childChange.e2;
        }
        if (!currentRange) {
          throw new Error("Cannot replace text in non-existing range");
        }
        currentRange.insertText(newText, Word.InsertLocation.replace);
        i++;
        break;
    }
  }
}
